import React from "react";
import { NavLink } from "react-router-dom";
import { Container, Grid, Header } from "semantic-ui-react";

import IParishPlacement from "../../../data/parish/ParishPlacement";
import IPriestMin from "../../../data/priest/PriestMin";
import BoldFM from "../../../util/styledMessages/BoldFM";
import ItalicFM from "../../../util/styledMessages/ItalicFM";
import DateDisplay from "../../DateDisplay";
import PlacementDropdown from "../../placements/PlacementDropdown";

interface IParishGeneralPlacementListProps {
    placements: IParishPlacement[];
    headerKey: string;
    editmode: boolean;
    placementType: string;
    setParish(
        priest: IPriestMin,
        type: string,
        startYear: string,
        startMonth: string,
        startDay: string,
        endYear: string,
        endMonth: string,
        endDay: string
    ): any;
}

const ParishGeneralPlacementList: React.FC<IParishGeneralPlacementListProps> = (props: IParishGeneralPlacementListProps) => {
    const { placements, headerKey, editmode, setParish, placementType } = props;

    return (
        <>
            <Header as="h2">
                <ItalicFM id={headerKey} />
            </Header>

            <Container style={{ marginBottom: "2em" }}>
                <Grid>
                    {placements ? (
                        <>
                            <Grid.Row columns={4} style={{ marginBottom: "-1em" }}>
                                <Grid.Column>
                                    <BoldFM id="label.name" />
                                </Grid.Column>
                                <Grid.Column>
                                    <BoldFM id="profile.workInterval" />
                                </Grid.Column>
                                <Grid.Column>
                                    {headerKey !== "label.priest.assistantPlacements" && <BoldFM id="profile.numberOfPeople" />}
                                </Grid.Column>
                            </Grid.Row>
                            {placements.map((placement: IParishPlacement, index: number) => (
                                <Grid.Row columns={4} key={placement.priestID + index} style={{ marginBottom: "-1em" }}>
                                    <Grid.Column>
                                        {placement.priestName ? (
                                            <NavLink className="hoverLink" to={`/priests/profile/${placement.priestID}`}>
                                                {placement.priestName}
                                            </NavLink>
                                        ) : (
                                            <ItalicFM id="general.noData" />
                                        )}
                                    </Grid.Column>
                                    <Grid.Column>
                                        <DateDisplay date={placement.startDate} /> - <DateDisplay date={placement.endDate} />
                                    </Grid.Column>
                                    <Grid.Column>{placement.numberOfPeople && <i>{placement.numberOfPeople}</i>}</Grid.Column>
                                    <Grid.Column />
                                </Grid.Row>
                            ))}
                        </>
                    ) : (
                        <ItalicFM id="general.noData" />
                    )}
                    {editmode && <PlacementDropdown placementType={placementType} setParish={setParish} />}
                </Grid>
            </Container>
        </>
    );
};

export default ParishGeneralPlacementList;
